const { uniqueNamesGenerator, adjectives, animals, colors } = require("unique-names-generator");

const randomName = uniqueNamesGenerator({
  dictionaries: [adjectives, colors, animals],
  length: 3
}); // big_red_donkey

export default randomName;
